import useLanguageStore from '../store/languageStore';

// Hook for easy access to language state in functional components
export const useLanguage = () => {
  const currentLanguage = useLanguageStore((state) => state.currentLanguage);
  const setLanguage = useLanguageStore((state) => state.setLanguage);
  const cycleLanguage = useLanguageStore((state) => state.cycleLanguage);
  const getCurrentLabel = useLanguageStore((state) => state.getCurrentLabel);
  
  return {
    currentLanguage,
    setLanguage,
    cycleLanguage,
    getCurrentLabel: getCurrentLabel()
  };
};

// Function for class components to get current language
export const getCurrentLanguage = () => {
  return useLanguageStore.getState().currentLanguage;
};

// Function for class components to get language store state
export const getLanguageStore = () => {
  return useLanguageStore.getState();
};

export default useLanguageStore;